module.exports = __webpack_public_path__ + "img/img3.5e468773.jpg";